import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "310",
  "slug": "spot-switzerland-from-satellite-imagery",
  "title": "How to Recognise Switzerland in Satellite Images",
  "excerpt": "The Swiss Alps occupy much of the south and centre.",
  "date": "2026-03-24",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/switzerland.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Swiss Alps occupy much of the south and centre. The lower Swiss Plateau lies to the north of the Alps, with the Jura farther northwest. Long lakes and the transitions between these terrain belts can help orient a regional view."
    },
    {
      "type": "heading",
      "text": "The Alps, the plateau, and the Jura"
    },
    {
      "type": "paragraph",
      "text": "Find Lake Geneva and follow the transition towards the Alps. Compare it with the lower terrain along the plateau rather than assuming all Swiss imagery is mountainous."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "The Alps continue into France, Italy, Austria, and other neighbours. A snowy peak or a chalet does not identify Switzerland. Compare the outline of a lake and the position of the nearby mountain front."
    }
  ],
  "imageAlt": "Switzerland regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
